var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal-body d-flex flex-column gap-20" },
      [
        _c("div", { staticClass: "d-flex flex-column gap-5" }, [
          _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Your input matters!")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "Share your thoughts, suggestions, or experiences using our services. Your feedback helps us improve. Thank you for being a part of our journey!"
                )
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column gap-10" }, [
          _c("strong", [
            _vm._v(_vm._s(_vm._f("trans")("How would you rate us?"))),
          ]),
          _vm._v(" "),
          _vm.feedbackManager?.showError
            ? _c("p", { staticClass: "text-danger m-0" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "Please enter a rating before submitting your feedback!"
                    )
                  )
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex gap-15" }, [
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rating,
                    expression: "rating",
                  },
                ],
                attrs: { type: "radio", value: "5" },
                domProps: { checked: _vm._q(_vm.rating, "5") },
                on: {
                  change: function ($event) {
                    _vm.rating = "5"
                  },
                },
              }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("trans")("Great")) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rating,
                    expression: "rating",
                  },
                ],
                attrs: { type: "radio", value: "4" },
                domProps: { checked: _vm._q(_vm.rating, "4") },
                on: {
                  change: function ($event) {
                    _vm.rating = "4"
                  },
                },
              }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("trans")("Good")) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rating,
                    expression: "rating",
                  },
                ],
                attrs: { type: "radio", value: "3" },
                domProps: { checked: _vm._q(_vm.rating, "3") },
                on: {
                  change: function ($event) {
                    _vm.rating = "3"
                  },
                },
              }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("trans")("Medium")) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rating,
                    expression: "rating",
                  },
                ],
                attrs: { type: "radio", value: "2" },
                domProps: { checked: _vm._q(_vm.rating, "2") },
                on: {
                  change: function ($event) {
                    _vm.rating = "2"
                  },
                },
              }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("trans")("Bad")) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rating,
                    expression: "rating",
                  },
                ],
                attrs: { type: "radio", value: "1" },
                domProps: { checked: _vm._q(_vm.rating, "1") },
                on: {
                  change: function ($event) {
                    _vm.rating = "1"
                  },
                },
              }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("trans")("Worse")) +
                  "\n            "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("TextArea", {
          staticClass: "w-100 feedback-text-area",
          attrs: {
            "border-class": "br-4",
            label: _vm.placeholder,
            "max-characters": 4000,
            rows: "4",
            value: _vm.creatorStudio.settings.prompt,
            aiCustom: true,
            name: "prompt",
            type: "text",
          },
          model: {
            value: _vm.message,
            callback: function ($$v) {
              _vm.message = $$v
            },
            expression: "message",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn close-btn",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.close.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "fa fa-times mr-1" }),
          _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Cancel")))]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn feedback-submit-btn",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.submitFeeback.apply(null, arguments)
            },
          },
        },
        [
          !_vm.feedbackManager?.loading
            ? _c("i", { staticClass: "fa fa-chevron-right" })
            : _vm._e(),
          _vm._v(" "),
          _vm.feedbackManager?.loading
            ? _c("i", { staticClass: "fa fa-spin btn-loading-animation" })
            : _vm._e(),
          _vm._v(" "),
          _c("strong", [
            _vm._v(
              "\n        " + _vm._s(_vm._f("trans")("Submit")) + "\n      "
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }